<div class="h-100 px-2 d-flex flex-column flex-1">

        <div class="loader" sample *ngIf="!environmentInfo"></div>
        <div class="mainContainer container-fuild d-flex flex-column flex-grow-1" sample *ngIf="environmentInfo">
            <app-add-servers 
                class="d-flex flex-column flex-grow-1" 
                *ngIf="wizardTabs[tabIndex]==EditActions.AddServer"
                [environmentInfo]="environmentInfo"
                [serverDetail]="serverDetail"
                [annualMachinesAllowed]="annualMachinesAllowed"
                (updateWizardStep)="onWizardTabChange($event)" 
                (passServerDetails)="passServerDetails($event)">
            </app-add-servers>
    </div>
</div>